import axios from 'axios';

const state = {};
const getters = {};

const actions = {
    lynk_list({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get('lynk-integrations')
                .then(res => { commit("PUSH_LYNK", "OK"); resolve(res); })
                .catch(err => reject(err));
        });
    },
    lynk_one({ commit }, id) {
        return new Promise((resolve, reject) => {
            axios.get('lynk-integration/' + id)
                .then(res => { commit("PUSH_LYNK", "OK"); resolve(res); })
                .catch(err => reject(err));
        });
    },
    lynk_create({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.post('lynk-integration', data)
                .then(res => { commit("PUSH_LYNK", "OK"); resolve(res); })
                .catch(err => reject(err));
        });
    },
    lynk_update({ commit }, data) {
        return new Promise((resolve, reject) => {
            const { id, ...payload } = data;
            axios.put('lynk-integration/' + id, payload)
                .then(res => { commit("PUSH_LYNK", "OK"); resolve(res); })
                .catch(err => reject(err));
        });
    },
    lynk_delete({ commit }, id) {
        return new Promise((resolve, reject) => {
            axios.delete('lynk-integration/' + id)
                .then(res => { commit("PUSH_LYNK", "OK"); resolve(res); })
                .catch(err => reject(err));
        });
    },
};

const mutations = {
    PUSH_LYNK() { /* no-op */ }
};

export default { state, getters, actions, mutations };
